module.exports = __webpack_public_path__ + "img/李翊.6b5e175c.jpg";